<template>
  <div id="app" class="main-container">
    <main>
      <router-view/>
    </main>
    <SectionFooter />
  </div>
</template>

<script>
import SectionFooter from '@/components/SectionFooter.vue'

export default {
  name: 'App',
  components: {
    SectionFooter,
  },
  computed: {
    loadingAnimation () {
      return this.$root.loadingAnimation
    }
  }
}
</script>


<style lang=scss>
@import 'assets/styles/_variable.scss';

* { box-sizing: border-box; }

html, body {
  margin: 0;
  font-family: $font-family-primary;
  background-color: $main-bg;
  font-size: 20px;
  line-height: 1.5em;
  text-align: left;
  color: $medium-text-color;

}

a {
  color: $dark-text-color;
}

h1,h2,h3,h4,h5,button {
  font-family: $font-family-primary;
  color: $dark-text-color;
}

h1 {
  font-size: 2em;
}

@import 'assets/styles/main.scss';


.main-container{
  display:flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  width: 100%;
  flex-grow: 1;
}

header, main, footer {
  flex-shrink: 0;
}

.hidden {
  display: none !important;
}

</style>
